/* eslint-disable no-case-declarations */
import actiontypes from "../actions/actiontypes";
import { handlePreAuthChallenge, setLoginError, setLoginSuccess, handleError } from "../actions/loginactioncreators";
import { put, takeLatest, call, select } from "redux-saga/effects";
import getloginClientId from "../helpers/getLoginClientId";
import { CognitoClient } from "../../lib/cognitoClient";

export function* authResponseHandler(action) {
    try {
        const payload = action.payload;
        const nextStep = payload.nextStep;

        switch (nextStep.signInStep) {
            case "DONE":
                const clientId = yield select(getloginClientId);
                const tokens = yield call(CognitoClient.getTokens, clientId);
                yield put(setLoginSuccess(tokens));
                break;
            case "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED":
                const userAttributes = nextStep.missingAttributes;
                yield put(handlePreAuthChallenge({ challengeName: "NEW_PASSWORD_REQUIRED", userAttributes }));
                break;
            case "CONTINUE_SIGN_IN_WITH_MFA_SELECTION":
                yield put(handlePreAuthChallenge({ challengeName: "SELECT_MFA_TYPE", challengeParameters: nextStep.allowedMFATypes }));
                break;
            // not in use, we don't do pre-auth set up
            case "CONTINUE_SIGN_IN_WITH_EMAIL_SETUP":
                yield put(handlePreAuthChallenge({ challengeName: "EMAIL_MFA", responseData: nextStep.codeDeliveryDetails }));
                break;
            // not in use, we don't do pre-auth set up
            case "CONTINUE_SIGN_IN_WITH_TOTP_SETUP":
                yield put(handlePreAuthChallenge({ challengeName: "SOFTWARE_TOKEN_MFA", responseData: nextStep.totpSetupDetails.sharedSecret }));
                break;
            case "CONFIRM_SIGN_IN_WITH_SMS_CODE":
                yield put(handlePreAuthChallenge({ challengeName: "SMS_MFA", challengeParameters: nextStep.codeDeliveryDetails }));
                break;
            case "CONFIRM_SIGN_IN_WITH_EMAIL_CODE":
                yield put(handlePreAuthChallenge({ challengeName: "EMAIL_MFA", challengeParameters: nextStep.codeDeliveryDetails }));
                break;
            case "CONFIRM_SIGN_IN_WITH_TOTP_CODE":
                yield put(handlePreAuthChallenge({ challengeName: "SOFTWARE_TOKEN_MFA" }));
                break;
            default:
                yield put(setLoginError("Login failed"));
        }
    } catch (error) {
        yield put(handleError(error));
    }
}

export function* watchAuthResponse() {
    yield takeLatest(actiontypes.USER_LOGIN_RESPONSE, authResponseHandler);
}